import React from 'react';
//import styles from './Submissions.css';

function Submissions() {
  return (
<div className="mainContent">
<h1>Submitting Your Script</h1>
            <p>Please email the script to <a href="mailto:info@ambassadorcommunications.biz">info@ambassadorcommunications.biz</a> and I will let you know how to send your payment to me. Thanks.</p>
</div>
  )
  }

export default Submissions;
